import React, { useMemo } from 'react';
import { arrayOf, string, number, func, node } from 'prop-types';
import { contextPropTypes } from '../../../proptypes/shared';
import TrailPropType from '../../../proptypes/TrailPropType';
import TrailResultCard from '../../cards/TrailResultCard';
import * as styles from './styles/styles.module.scss';
import River from '../../shared/River';
import ShowMoreCard from './ShowMoreCard';
import TrailRiverShimmer from '../../shimmers/TrailRiverShimmer';
import { HOME_PAGE_WIDTH_BREAKPOINT } from '../../../utils/constants/breakpoints';

const slickSettings = { slidesToShow: 4, lazyLoad: 'progressive', slidesToScroll: 4, speed: 750 };
const ARROW_STYLES = { next: styles.next, previous: styles.previous };
const TrailRiver = ({ hits, title, windowWidth, context, className, trailCardLinkRef, listMethods }) => {
  const isWideScreen = useMemo(() => {
    return windowWidth && windowWidth >= HOME_PAGE_WIDTH_BREAKPOINT;
  }, [windowWidth]);

  if (!hits) {
    return <TrailRiverShimmer className={className} />;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={`${styles.title} xlate-none`}>{title}</div>
      <div className={styles.riverContainer}>
        <River useSlick={isWideScreen} slickSettings={slickSettings} className={styles.riverClass} arrowStyles={ARROW_STYLES}>
          {hits.map((hit, idx) => (
            <div className={styles.trailCardContainer} data-testid={`${title}`} key={hit.ID || hit.exploreMoreUrl}>
              {hit.exploreMoreUrl ? (
                <ShowMoreCard url={hit.exploreMoreUrl} />
              ) : (
                <TrailResultCard
                  className={`${styles.trailCard} ${context.mobileBrowser ? '' : styles.hoverAnimation}`}
                  allowItemMoving={false}
                  context={context}
                  handleFavoriteClick={() => listMethods.handleFavoriteClick(hit.type, hit.ID, hit.objectID)}
                  idx={idx}
                  isCompleted={listMethods.isComplete(hit.type, hit.ID)}
                  isFavorite={listMethods.isFavorite(hit.type, hit.ID)}
                  isVerified={listMethods.isVerified(hit.type, hit.ID)}
                  key={`trail-${hit.ID}`}
                  showFavoriteHeart
                  tabletBrowser={context.tabletBrowser}
                  trail={hit}
                  maxInitPhotos={1}
                  maxPhotos={1}
                  linkRef={trailCardLinkRef}
                />
              )}
            </div>
          ))}
        </River>
      </div>
    </div>
  );
};

TrailRiver.propTypes = {
  hits: arrayOf(TrailPropType),
  title: node.isRequired,
  windowWidth: number,
  context: contextPropTypes.isRequired,
  handleFavoriteClick: func,
  className: string
};

TrailRiver.defaultProps = {
  hits: null,
  windowWidth: null,
  handleFavoriteClick: () => {},
  className: ''
};

export default TrailRiver;
